import React from "react";
import { Bot } from "lucide-react";

const ChatBubble = ({ isOpen, onClick }) => {
    return (
        <button
            onClick={onClick}
            className={`
                fixed ${isOpen ? 'bottom-20 right-16' : 'bottom-20 right-16'}
                w-14 h-14 rounded-full
                bg-gradient-to-br from-acs-primary-green to-teal-400
                shadow-lg hover:shadow-xl
                flex items-center justify-center
                transition-all duration-300 ease-in-out
                hover:scale-110 active:scale-95
                z-[70]
            `}
            aria-label="Toggle AI Chat"
        >
            <Bot
                className="w-7 h-7 text-white"
            />
        </button>
    );
};

export default ChatBubble;
